module.exports = __webpack_public_path__ + "img/icon_sm_jccdj.33c128f4.png";